<div fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="gs-dialog-header" mat-dialog-title>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <img src="assets/img/chatbot-ai.png" class="gs-dialog-logo" alt="KumoAgent" />
      <div>
        <div class="gs-dialog-title">Global Search</div>
        <div class="gs-dialog-subtitle">Search across blueprints, instances and devices</div>
      </div>
    </div>
    <button type="button" mat-icon-button class="text-secondary" (click)="onClose()">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>
  <mat-divider class="-mx-6 text-border"></mat-divider>
  <mat-sidenav-container class="example-container" [ngStyle]="{ height: getHeight(150) }">
    <mat-sidenav #sidenav mode="side" position="end">
      <div
        id="right-nav-global-search"
        class="right-nav gs-agent-panel"
        [style.width.px]="right_width"
        [ngStyle]="{ height: getHeight(150) }"
      >
        <ng-container *ngIf="!isShowEditor">
          <div fxLayout="row" fxLayoutAlign="space-between center" class="header border-b">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <img src="assets/img/chatbot-ai.png" class="gs-header-logo" alt="KumoAgent" />
              <div class="title">Ask KumoAgent</div>
            </div>
            <button mat-raised-button color="primary" type="button" class="ml-2" (click)="openCloseSidenav()">
              <mat-icon [icIcon]="faDoubleRight"></mat-icon>
            </button>
          </div>
          <div class="gs-selection-strip border-b">
            <mat-chip-list class="chip-list">
              <ng-container *ngIf="!showAll">
                <mat-chip *ngFor="let data of selectedItem.slice(0, 1)" class="chip-margin" [removable]="true" (removed)="remove(data)">
                  {{ data.itemType }}: {{ data.itemName }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <mat-chip *ngIf="selectedItem.length > 1" class="chip-margin" (click)="toggleChips()" style="cursor:pointer">
                  +{{ selectedItem.length - 1 }}
                </mat-chip>
              </ng-container>
              <ng-container *ngIf="showAll">
                <mat-chip *ngFor="let data of selectedItem" class="chip-margin" [removable]="true" (removed)="remove(data)">
                  {{ data.itemType }}: {{ data.itemName }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </mat-chip-list>
          </div>

          <!-- Welcome state with quick chips when no messages yet -->
          <ng-container *ngIf="!messages?.length">
            <div class="gs-chat-welcome">
              <img src="assets/img/chatbot-ai.png" class="gs-chat-welcome-logo" alt="KumoAgent" />
              <p class="gs-chat-welcome-text">Ask KumoAgent about the selected resources</p>
              <div class="gs-chat-chips">
                <button class="gs-chat-chip" (click)="sendQuickMessage('Summarize the selected resources')">Summarize</button>
                <button class="gs-chat-chip" (click)="sendQuickMessage('Find any issues or misconfigurations in these resources')">Find Issues</button>
                <button class="gs-chat-chip" (click)="sendQuickMessage('What are best practices for these resources?')">Best Practices</button>
                <button class="gs-chat-chip" (click)="sendQuickMessage('Compare the configurations of these resources')">Compare</button>
              </div>
            </div>
          </ng-container>

          <div id="chatElement" class="gs-chat-scroll p-4 overflow-auto">
            <vex-scrollbar class="flex-auto">

              <ng-container *ngFor="let message of messages">
                <!-- User message -->
                <ng-container *ngIf="message.from === 'me'">
                  <div class="gs-user-turn">
                    <div class="gs-user-content">
                      <div class="gs-user-bubble">
                        <span [innerHTML]="message.textMessage"></span>
                      </div>
                      <div class="turn-meta turn-meta-right">
                        <span class="text-xs text-secondary">{{ message.timestamp }}</span>
                      </div>
                    </div>
                    <div class="gs-user-avatar">U</div>
                  </div>
                </ng-container>
                <!-- AI message -->
                <ng-container *ngIf="message.from === 'partner'">
                  <div class="gs-ai-turn">
                    <img src="assets/img/chatbot-ai.png" class="gs-ai-avatar-img" alt="KA" />
                    <div class="gs-ai-content">
                      <div class="gs-ai-body" (click)="onMarkdownClick($event)">
                        <markdown class="markdown" [data]="message.message" #markdownContent></markdown>
                      </div>
                      <div class="turn-meta">
                        <span class="text-xs text-secondary">{{ message.timestamp }}</span>
                        <mat-icon class="action-icon" (click)="copyToClipboard(markdownContent, message)">
                          {{ message.isCopied ? 'check_circle' : 'file_copy' }}
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Typing indicator -->
              <ng-container *ngIf="fetchingAiResponse">
                <div class="gs-ai-turn">
                  <img src="assets/img/chatbot-ai.png" class="gs-ai-avatar-img" alt="KA" />
                  <div class="gs-ai-content">
                    <div class="gs-ai-body thinking-row">
                      <div class="typing-indicator"><span></span><span></span><span></span></div>
                      <span class="thinking-text">{{ thinkingLabel }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>

            </vex-scrollbar>
          </div>

          <div class="gs-input-area p-3 border-t">
            <div class="gs-prompt-box">
              <textarea
                class="gs-prompt-textarea"
                [(ngModel)]="query"
                placeholder="Ask KumoAgent..."
                rows="1"
                (keydown)="handleKeydown($event)"
                #textarea
              ></textarea>
              <button
                mat-icon-button
                type="button"
                [class.send-active]="hasValidInput()"
                [disabled]="!hasValidInput() || fetchingAiResponse"
                (click)="send()"
              >
                <mat-icon [icIcon]="icSend"></mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isShowEditor">
          <div fxLayout="row" fxLayoutAlign="space-between center" class="header border-b">
            <div class="title">View Config</div>
            <button
              mat-raised-button
              color="primary"
              type="button"
              class="ml-2"
              (click)="openCloseSidenav()"
            >
              <mat-icon [icIcon]="faDoubleRight"></mat-icon>
            </button>
          </div>
          <div class="section">
            <div fxLayout="row" class="mt-4">
              <div class="overflow-y-auto" fxFlex="auto" [ngStyle]="{ height: getHeight(282) }">
                <div fxLayout="row" fxLayoutAlign="space-around center" *ngIf="loadEditor">
                  <mat-progress-spinner
                    class="progbar"
                    strokeWidth="4"
                    diameter="60"
                    mode="indeterminate"
                    color="primary"
                  >
                  </mat-progress-spinner>
                </div>
                <ngx-monaco-editor
                  style="height: 100%"
                  [options]="editorOptions"
                  [(ngModel)]="code"
                  (init)="editorInit($event)"
                >
                </ngx-monaco-editor>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="grabber" id="change_div_size"></div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="gs-search-bar-row border-b">
        <div class="gs-search-inner">
          <div class="gs-search-input-wrap">
            <ic-icon [icon]="icSearch" size="18px" class="gs-search-icon"></ic-icon>
            <input
              type="text"
              class="gs-search-input"
              placeholder="Search blueprints, instances, devices…"
              [(ngModel)]="filter.Filter"
              (input)="filterSubject$.next($event.target.value)"
            />
          </div>
          <div class="gs-filter-chips">
            <button class="gs-filter-chip" [class.gs-filter-chip-active]="isCheckAllButton()" (click)="onClickAll()">All</button>
            <button class="gs-filter-chip gs-chip-blueprint" [class.gs-filter-chip-active]="isCheckButton('blueprint')" (click)="onClickItem('blueprint')">Blueprint</button>
            <button class="gs-filter-chip gs-chip-instance" [class.gs-filter-chip-active]="isCheckButton('inventory')" (click)="onClickItem('inventory')">Instance</button>
            <button class="gs-filter-chip gs-chip-device" [class.gs-filter-chip-active]="isCheckButton('device')" (click)="onClickItem('device')">Device</button>
          </div>
        </div>
        <button *ngIf="selectedItem.length && !sidenav.opened"
          mat-stroked-button color="primary" class="gs-ask-btn" (click)="openCloseSidenav()">
          <img src="assets/img/chatbot-ai.png" style="width:16px;height:16px;border-radius:50%;margin-right:6px;" />
          Ask KumoAgent ({{ selectedItem.length }})
        </button>
      </div>
      <div class="gs-results-wrapper">

        <!-- Empty search state -->
        <ng-container *ngIf="!filter.Filter && !data?.length">
          <div class="gs-empty-state">
            <mat-icon class="gs-empty-icon">search</mat-icon>
            <p class="gs-empty-text">Type to search across your infrastructure</p>
          </div>
        </ng-container>

        <!-- Results -->
        <ng-container *ngIf="filter.Filter || data?.length">
          <div class="gs-results-header" *ngIf="resultsLength">
            <span class="gs-results-count"><strong>{{ resultsLength }}</strong> results</span>
            <span class="gs-results-hint">Select items then ask KumoAgent</span>
          </div>
          <div class="gs-results-scroll">
            <div class="my-4" fxLayout="row" fxLayoutAlign="space-around center" *ngIf="fetchspinner; else content">
              <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary">
              </mat-progress-spinner>
            </div>
            <ng-template #content>
              <ng-container *ngFor="let card of data">
                <vex-global-search-card
                  [item]="card"
                  (openConfig)="openConfig($event)"
                  (onSelectCheckBox)="onSelectCheckBox($event)"
                  [selectedItem]="selectedItem"
                >
                </vex-global-search-card>
              </ng-container>
            </ng-template>
          </div>
        </ng-container>

        <!-- Sticky paginator -->
        <mat-paginator *ngIf="resultsLength"
          class="gs-paginator"
          [pageSizeOptions]="pageSizeOptions"
          [length]="resultsLength"
          (page)="setGridParams()"
          [pageSize]="pageSize"
          showFirstLastButtons
        >
        </mat-paginator>

      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
